// Per-task-type visual config for the calendar (icon + label + chip classes).
// Record<TaskType, …> makes this exhaustive at compile time; the sibling unit
// test asserts every TaskType resolves at runtime. Colors are intentionally
// distinct from job chips so the office never confuses a task with a job.

import { ClipboardList, Truck, Wrench, Phone, type LucideIcon } from 'lucide-react';
import { TASK_TYPE_LABELS, type TaskType } from '@gutterinv/shared';

export interface TaskStyle {
  label: string;
  Icon: LucideIcon;
  /** Tailwind classes for the pill (bg + text + border). */
  chip: string;
  /** Solid dot color (month view), CSS color string. */
  dot: string;
}

export const TASK_STYLES: Record<TaskType, TaskStyle> = {
  physical_inventory: {
    label: TASK_TYPE_LABELS.physical_inventory,
    Icon: ClipboardList,
    chip: 'bg-slate-100 text-slate-700 border-slate-300',
    dot: '#64748b',
  },
  receive_delivery: {
    label: TASK_TYPE_LABELS.receive_delivery,
    Icon: Truck,
    chip: 'bg-amber-100 text-amber-800 border-amber-300',
    dot: '#d97706',
  },
  truck_maintenance: {
    label: TASK_TYPE_LABELS.truck_maintenance,
    Icon: Wrench,
    chip: 'bg-sky-100 text-sky-800 border-sky-300',
    dot: '#0284c7',
  },
  contact_danny: {
    label: TASK_TYPE_LABELS.contact_danny,
    Icon: Phone,
    chip: 'bg-violet-100 text-violet-800 border-violet-300',
    dot: '#7c3aed',
  },
};

export function taskStyle(type: TaskType): TaskStyle {
  return TASK_STYLES[type];
}
